import { render } from "./MaintenanceItemsConfigitemCompany.vue?vue&type=template&id=796e5de0"
import script from "./MaintenanceItemsConfigitemCompany.vue?vue&type=script&lang=js"
export * from "./MaintenanceItemsConfigitemCompany.vue?vue&type=script&lang=js"

import exportComponent from "/Users/user/Desktop/prod/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__